module.exports = __webpack_public_path__ + "static/media/emotions.e4e2762d.svg";